import { createUseStyles } from 'react-jss';
import { CustomCiamUiTheme } from '../../../theme';
import '@fontsource/roboto/300.css';

export default createUseStyles(
  {
    '@keyframes skeleton': {
      from: { opacity: 0.2 },
      to: { opacity: 1 },
    },
    root: {
      background: ({ theme }: { theme: CustomCiamUiTheme }) =>
        theme.backgroundColor,
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
    },
    logo: {
      animation: '$skeleton 1s infinite ease-in-out alternate',
    },
    subtitle: {
      fontSize: 24,
      color: 'white',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: `300 !important`,
      animation: '$skeleton 1s infinite ease-in-out alternate',
    },
  },
  {
    name: 'LoadingScreen',
  },
);
